import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../components/mui/Dialogue/GlobalDeleteDialog";
import { deleteBatch, getBatchesList } from "../../redux/features/batchSlice";

const DeleteBatch = ({ id, dispatchdata, disabled }) => {
  const { loading } = useSelector((state) => state.batch);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete batch"}
      disabled={disabled}
      deleteNote={"Are you sure? you want to delete this batch..?"}
      api={deleteBatch([id])}
      upDateCall={getBatchesList(dispatchdata)}
      loading={loading}
    />
  );
};

export default DeleteBatch;
